import React from "react";
import ShowAfterDelay from "./ShowAfterDelay";
import { ActivePromoForCruise } from "src/utils/promos";
import { dateFromOptionalDate } from "src/utils/date";
import { ECommerceStatus } from "src/ssc-api/useECommerceStatus";
import { match } from "ts-pattern";
import OfferUrgencyBox from "./OfferUrgencyBox";
import { useLingui } from "@lingui/react/macro";
import ClientOnly from "components/ClientOnly";

type Props = {
  offerContent: ActivePromoForCruise;
  ecommerceUrl: ECommerceStatus;
};

const CruiseOfferUrgencyBox: React.FC<Props> = ({
  offerContent,
  ecommerceUrl
}) => {
  const { t } = useLingui();
  const expirationDate = dateFromOptionalDate(offerContent.toDate);

  const ctaUrl = match(ecommerceUrl)
    .with({ type: "ecommerce" }, ({ ecommerceUrl }) => ecommerceUrl)
    .with({ type: "priceconfig" }, ({ url }) => url)
    .otherwise(() => undefined);

  if (!ctaUrl) return null;

  return (
    <ClientOnly>
      <ShowAfterDelay enabled>
        <React.Suspense>
          <OfferUrgencyBox
            title={offerContent.content.title?.localized ?? t`Exclusive Offer`}
            content={
              offerContent.content.urgencyBoxContent?.localized ??
              t`This voyage will be discounted for a short time`
            }
            countdownLabel={offerContent.content.countdownLabel?.localized}
            expirationDate={expirationDate}
            ctaLabel={t`Book your suite`}
            ctaUrl={ctaUrl}
            showCountdown={offerContent.content.showCountdown ?? false}
          />
        </React.Suspense>
      </ShowAfterDelay>
    </ClientOnly>
  );
};

export default CruiseOfferUrgencyBox;
